"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundsWarehouseScannerClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const OutboundPackageScanError_1 = require("./OutboundPackageScanError");
const OUTBOUND_PACKAGE_SCAN_ERRORS = Object.values(OutboundPackageScanError_1.OutboundPackageScanError);
class OutboundsWarehouseScannerClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: `${process.env.OUTBOUNDS_WAREHOUSE_SCANNER_URL}/app`,
        basicAuthUser: process.env.OUTBOUNDS_WAREHOUSE_SCANNER_BASIC_AUTH_USER,
        basicAuthPassword: process.env.OUTBOUNDS_WAREHOUSE_SCANNER_BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("OUTBOUNDS_WAREHOUSE_SCANNER_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("OUTBOUNDS_WAREHOUSE_SCANNER_BASIC_AUTH_USER and/or OUTBOUNDS_WAREHOUSE_SCANNER_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async processPackageLoadingScan(barcode, warehouseId) {
        var _a;
        try {
            return await this.put(`/v1/package/${barcode}/load`, {
                warehouseId,
            });
        }
        catch (error) {
            if (OUTBOUND_PACKAGE_SCAN_ERRORS.includes((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.code)) {
                throw new errors_1.DeliverrError(error.response.data);
            }
            else {
                throw (0, base_client_1.mapError)(error);
            }
        }
    }
}
exports.OutboundsWarehouseScannerClient = OutboundsWarehouseScannerClient;
//# sourceMappingURL=OutboundsWarehouseScannerClient.js.map